'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdAvTimer = function MdAvTimer(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm10 20c0-0.9 0.7-1.6 1.6-1.6s1.8 0.7 1.8 1.6-0.8 1.6-1.8 1.6-1.6-0.7-1.6-1.6z m20 0c0 0.9-0.7 1.6-1.6 1.6s-1.8-0.7-1.8-1.6 0.8-1.6 1.8-1.6 1.6 0.7 1.6 1.6z m-11.6-15h1.6c8.3 0 15 6.7 15 15s-6.7 15-15 15-15-6.7-15-15c0-4.9 2.3-9.2 6-12v0l11.3 11.3-2.3 2.3-9.1-8.9c-1.6 2-2.5 4.5-2.5 7.3 0 6.5 5.1 11.6 11.6 11.6s11.6-5.1 11.6-11.6c0-5.9-4.3-10.8-10-11.6v3.2h-3.2v-6.6z m0 23.4c0-1 0.7-1.8 1.6-1.8s1.6 0.8 1.6 1.8-0.7 1.6-1.6 1.6-1.6-0.7-1.6-1.6z' })
        )
    );
};

exports.default = MdAvTimer;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/av-timer.js
// module id = 492
// module chunks = 0